export default {
  props: {
    draggable: Boolean,
  },
  mounted(){
    if (!this.draggable) return;
    this.openDragable();
  },
  beforeDestroy(){
    const eleDialogHeader = this.$refs.refDialogHeader;
    eleDialogHeader.onmousedown = null;
    eleDialogHeader.onmousemove = null;
    document.onclick = null;
    document.onmouseup = null;
    document.onvisibilitychange = null;
    document.onerror = null;
    this.x = 0;
    this.y = 0;
  },
  methods: {
    openDragable(){
      const eleDialog = this.$refs.refDialog;
      const eleDialogHeader = this.$refs.refDialogHeader;
      eleDialogHeader.style.cursor = 'move';
      eleDialogHeader.style.userSelect = 'none';

      const removeMousemove = () => {
        eleDialogHeader.onmousemove = null;
      }
      document.onclick = removeMousemove;
      document.onmouseup = removeMousemove;
      document.onvisibilitychange = removeMousemove;
      document.onerror = removeMousemove;

      eleDialogHeader.onmousedown = (event) => {
        const startTranslateX = this.x || 0
        const startTranslateY = this.y || 0
        const x = startTranslateX - event.clientX;
        const y = startTranslateY - event.clientY;

        eleDialogHeader.onmousemove = (event) => {
          this.x = x + event.clientX;
          this.y = y + event.clientY;
          eleDialog.style.setProperty('transform', `translate(${this.x}px, ${this.y}px)`);
        } 
      }
    }
  }
}